import { useEffect, useRef } from 'react';
import { backButton, mainButton } from '@telegram-apps/sdk-react';
import { useNavigate } from 'react-router-dom';

import {
  popBackHandler,
  pushBackHandler,
  triggerBack
} from '@/hooks/manager/backButtonManager.ts';

export const useBackButtonToPrevRoute = (
  path?: string,
  hideBackButton: boolean = true,
  enabled: boolean = true
) => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    scrollContainerRef.current =
      document.querySelector('#root') || document.body;
  }, []);

  useEffect(() => {
    if (!enabled) {
      if (backButton.isVisible()) {
        backButton.hide();
      }
      return;
    }

    const handler = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.style.overflowY = 'hidden';
      }

      if (path) {
        navigate(path);
      } else {
        navigate(-1);
      }

      if (hideBackButton && backButton.isVisible()) {
        backButton.hide();
      }

      mainButton.setParams({ isVisible: false });

      setTimeout(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.style.overflowY = '';
        }
      }, 50);
    };

    pushBackHandler(handler);

    if (!backButton.isVisible()) {
      backButton.show();
    }

    backButton.onClick(triggerBack);

    return () => {
      popBackHandler(handler);
    };
  }, [enabled]);

  return { backButtonInstance: backButton };
};
